import { useEffect } from 'react';
import { useSocket } from './useSocket';

export const useSubscriber = (event: string, handler): void => {
  const socket = useSocket();

  useEffect(() => {
    socket.on(event, handler);

    return () => {
      socket.off(event);
    };
  }, [socket, event, handler]);
};

export const SOCKET_EVENTS = {
  ENOCH: {
    MACHINE_STATE: 'ENOCH_MACHINE_STATE',
  },
};
